/**
 * useFlags / useFlag — feature flags de SOA 10 PRO (tabla CONFIG, claves ff_*).
 * Cada bloque nuevo va detrás de un flag: si algo falla en las pruebas se apaga y el OS abre igual.
 * Se cargan una vez por sesión (y cada 5 min); un flag que no llegó vale `false` (apagado).
 *   const triage = useFlag("ff_triage");
 */
import { useEffect, useState } from "react";
import { api } from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";

let cache = null;
const oyentes = new Set();
let cargando = null;

async function cargar() {
  if (cargando) return cargando;
  cargando = api.getFlags()
    .then(r => { cache = r?.flags || {}; oyentes.forEach(f => f(cache)); })
    .catch(() => { cache = cache || {}; })
    .finally(() => { cargando = null; });
  return cargando;
}

// Overrides locales (solo este navegador) para probar un bloque sin encenderlo para todos:
//   localStorage.setItem("crew_flags", JSON.stringify({ ff_cmdk_crear: true }))
function overrides() {
  try { return JSON.parse(localStorage.getItem("crew_flags") || "{}") || {}; } catch { return {}; }
}

export function useFlags() {
  const { miembro } = useAuth();
  const [flagsServidor, setFlags] = useState(cache || {});
  const flags = { ...flagsServidor, ...overrides() };
  useEffect(() => {
    if (!miembro) return;
    oyentes.add(setFlags);
    cargar();
    const t = setInterval(cargar, 5 * 60 * 1000);
    return () => { oyentes.delete(setFlags); clearInterval(t); };
  }, [miembro?.id]);
  return flags;
}

export const useFlag = (key) => !!useFlags()[key];

/** Fuerza recargar (se usa tras cambiar un flag desde Ajustes). */
export const recargarFlags = () => { cache = null; return cargar(); };
